<template>
  <div class="upload-file">
    <v-alert v-if="errors.has('photoUpload')" :value="showAlert" type="error" dismissible>
      {{ errors.first('photoUpload') }}
    </v-alert>
    <template v-if="currentImage">
      <div
        class="text-center preview-img"
        style="
          overflow: hidden;
          min-height: 150px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        "
        :style="{
          'min-height': height + 'px',
          'background-image': 'url(\'' + currentImage + '\')'
        }"
      >
        <template v-if="loading">
          <div
            style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
          >
            <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
          </div>
        </template>
        <div v-else class="overlay">
          <v-layout
            justify-center
            fill-height
            align-center
            row
            class="mb-0"
            style="min-height: 100%"
            :style="{ 'min-height': height + 'px' }"
          >
            <div @click="onClickUploadButton">
              <slot>
                <v-btn small depressed color="primary" style="font-size: 11px">
                  <span class="fa fa-camera mr-1"></span>
                  {{ $t('select file to upload') }}
                </v-btn>

                <div class="caption text-xs-center" style="color: white">
                  {{ $t('upload file size: {size}MB', { size: 5 }) }}
                </div>
              </slot>
            </div>
          </v-layout>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text-xs-center">
        <div
          style="min-height: 150px; background: #eee; overflow: hidden; position: relative"
          :style="{ 'min-height': height + 'px' }"
        >
          <template v-if="loading">
            <div
              style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            >
              <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
            </div>
          </template>
          <template v-else>
            <v-layout
              justify-center
              fill-height
              align-center
              row
              class="mb-0"
              style="min-height: 100%"
              :style="{ 'min-height': height + 'px' }"
            >
              <div @click="onClickUploadButton">
                <slot>
                  <v-btn small depressed color="primary" style="font-size: 11px">
                    <span class="fas fa-file-alt mr-2"></span>
                    {{ $t('select file to upload') }}
                  </v-btn>

                  <div class="caption grey--text text-xs-center">
                    {{ $t('upload file size: {size}MB', { size: fileSize }) }}
                  </div>
                </slot>
              </div>
            </v-layout>
          </template>
        </div>
      </div>
    </template>

    <input
      :id="'photoUploadInput' + objId"
      v-validate="
        'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,video/mp4,video/quicktime,audio/mpeg,audio/wav,application/pdf,application/zip,text/csv,text/plain,application/vnd.rar,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel'
      "
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      data-vv-as="File"
      :multiple="multiple"
      accept=".xlsx,.mp4,.mov,.txt,.zip,.text,.pdf,text/plain,.csv,.rar,.doc,.docx"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
      @change="onFileChange($event)"
    />
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import dayjs from 'dayjs'

export default {
  components: {
    SyncLoader
  },
  props: {
    value: null,
    height: {
      default: 250,
      type: Number
    },
    outputtype: {
      default: 'url',
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      filelength: 0,
      multiplefile: [],
      base64img: '',
      currentImage: this.value,
      loading: false,
      objId: null,
      uploadtimestamp: dayjs().format('x'),
      fileSize: 25,
      showAlert: false
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.currentImage = newVal
    }
  },
  created: function () {
    // if (!this.height || this.height === 'undefined') {
    // 	this.height = 250
    // }
    this.objId = Math.random()
  },
  methods: {
    onClickUploadButton: function () {
      document.getElementById('photoUploadInput' + this.objId).click()
    },
    fileResize: function (file) {
      let vm = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function () {
          var tempImg = new Image()
          tempImg.src = reader.result
          tempImg.onload = function () {
            var MAX_WIDTH = 2000
            var MAX_HEIGHT = 2000
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            var tempW = tempImg.width
            var tempH = tempImg.height
            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }

            var canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH
            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            var dataURL = canvas.toDataURL('image/jpeg')
            var data = 'image=' + dataURL
            try {
              if (vm.outputtype == 'base64') {
                vm.$emit('input', dataURL)
                vm.currentImage = dataURL
                vm.$emit('onUploaded', dataURL)
              }
              var obj = vm.dataURItoBlob(data)
              obj.name = file.name
              resolve(obj)
            } catch (error) {
              vm.$swal({
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                type: 'error',
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t('Confirm')
              })
              reject()
            }
          }
        }
        reader.readAsDataURL(file)
      })
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function (event) {
      var vm = this
      if (event && event.target && event.target.files && event.target.files.length) {
        for (let i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i]
          if (file.size > vm.fileSize * 1024 * 1024) {
            vm.$swal.fire({
              type: 'error',
              title: 'File Is Too Large'
            })
            return
          }
        }
      }
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.showAlert = true
        this.uploadtimestamp = dayjs().format('x')
        return
      } else {
        this.showAlert = false
        this.loading = true
        let files = event.target.files || event.dataTransfer.files
        if (!files.length) {
          this.uploadtimestamp = dayjs().format('x')
          return
        } else {
          vm.filelength = files.length
        }
        if (vm.multiple) {
          for (let file of files) {
            // var obj = await vm.fileResize(file)
            await vm.createImage(file)
          }
        } else {
          // console.log('loading is ' + this.loading)
          vm.createImage(files[0])
        }
        event.target.value = ''

        this.loading = false
      }
    },
    async createImage(file) {
      try {
        await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequestV1(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          vm.loading = false
          vm.$emit('input', vm.currentImage)
          if (vm.multiple) {
            vm.multiplefile.push({ url: vm.currentImage, name: file.name })
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
              vm.multiplefile = []
            }
          }
          resolve()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/UploadalltypeIcon.vue